import { OnInit, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';

import { PatientSubscriptionDto } from './../DTOs/Patients/Models/patient-subscription.dto';
import { CreatePatientCommand } from '../DTOs/Patients/Commands/CreatePatientCommand';
import { UpdatePatientCommand } from '../DTOs/Patients/Commands/UpdatePatientCommand';
import { AppConfigService, AppConfig } from '../services/app-config.service';
import { AuthService } from '../auth/auth.service';
import { map } from 'rxjs/operators';

@Injectable()
export class PatientService implements OnInit {
    
  public appConfig: AppConfig = new AppConfig();

  constructor(private http: HttpClient,
    private appConfigService: AppConfigService,
    private authService: AuthService) {

    this.appConfig = this.appConfigService.getConfig();

    if (environment.debug_mode) {
      console.log("PatientService, oc_api_url: " + this.appConfig.oc_api_url);
    }

  }

  ngOnInit(): void {
  }

  //-----------------------------------------------------------
  //get Search List with Observable - begin
  //-----------------------------------------------------------
  //map return an Observable
  //subscribe returns a subscription
  searchPatients(orgId: string, patient: string, centerId: string, currentPage: number = 1, pageLimit: number = 20): Observable<any> {

    

    let url = this.appConfig.oc_api_url + environment.oc_api_centers_url + "patients?patient=" + patient + "&centerId=" + centerId + "&currentPage=" + currentPage + "&pageSize=" + pageLimit;

    return this.http.get(url);


  }
  //-----------------------------------------------------------
  //get Search Product List with Observable - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get Patient - begin
  //-----------------------------------------------------------
  getPatient(orgId: string, patientId: string): Observable<any> {

    

    let url: string = this.appConfig.oc_api_url + environment.oc_api_centers_url + "patient?id=" + patientId;

    if (environment.debug_mode) {
      console.log("getPatient: " + url);
    }

    return this.http.get(url)

  }
  //-----------------------------------------------------------
  //get Patient - end
  //-----------------------------------------------------------

  //---------------------------------------------------------
  // createPatient - begin
  //---------------------------------------------------------
  createPatient(createCmd: CreatePatientCommand): Observable<any> {
    

    let url: string = this.appConfig.oc_api_url + environment.oc_api_centers_url + "patient";

    if (environment.debug_mode) {
      console.log("createPatient: " + JSON.stringify(createCmd));
      console.log("createPatient url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(createCmd));
  }
  //---------------------------------------------------------
  // createPatient - end
  //---------------------------------------------------------    


  //-----------------------------------------------------------
  //upate Patient - begin
  //-----------------------------------------------------------
  updatePatient(updCmd: UpdatePatientCommand): Observable<any> {

    

    let url: string = this.appConfig.oc_api_url + environment.oc_api_centers_url + "patient";

    if (environment.debug_mode) {
      console.log("updatePatient: " + JSON.stringify(updCmd));
      console.log("updatePatient url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(updCmd));

  }
  //-----------------------------------------------------------
  //update Patient - end
  //-----------------------------------------------------------

  patientIsExcludedFromAftercareCommsCurnex(patientId: string, tenantId: string): Observable<boolean> {
    const url: string =
      this.appConfig.curnex_api_url + 
      "entities/"+tenantId+"/patient/"+patientId+"/tags/NoAftercareComms";
      //to handle curnex text response type
    return this.http.get(url,{ responseType: 'text' }).pipe(map(x => x && x.toLocaleLowerCase() == "true"));
  }

  checkContactDetailsStatus(patientId: string, tenantId: string): Observable<{ EmailStatus: string, MobileStatus: string }> {
    const url: string =
      this.appConfig.curnex_api_url +
      `entities/${tenantId}/patient/${patientId}/normalization-statuses`;
    return this.http.get<any>(url).pipe(
      map(res => ({
        EmailStatus: res.emailNormalizationStatus,
        MobileStatus: res.mobileNormalizationStatus
      }))
    );
  }

  excludePatientFromAftercareCommsCurnex(patientId: string, tenantId: string) {
    const url: string =
      this.appConfig.curnex_api_url + 
      "entities/"+tenantId+"/patient/"+patientId+"/tags/NoAftercareComms";
      //to handle curnex text response type
    return this.http.post(url, {}, { responseType: 'text' });
  }

  unexcludePatientFromAftercareCommsCurnex(patientId: string, tenantId: string) {
    const url: string =
      this.appConfig.curnex_api_url + 
      "entities/"+tenantId+"/patient/"+patientId+"/tags/NoAftercareComms";
      //to handle curnex text response type
    return this.http.delete(url,{ responseType: 'text' });
  }

  synchronizePatientWithCurnex(patientId: string, centerId: string) {
    const syncUrl = this.appConfig.oc_api_url+environment.oc_api_centers_url+"curnex-sync"
    const data = {
      PatientId: patientId,
      CenterId: centerId
    };
    if (environment.debug_mode) {
      console.log("synchronizePatientWithCurnex: " + JSON.stringify(data));
      console.log("synchronizePatientWithCurnex url: " + syncUrl);
    }
    return this.http.post(syncUrl, data);
  }

  getPatientSubscription(patientId: string): Observable<PatientSubscriptionDto> {

    

    const url: string = this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      `subscription-management/${patientId}`;

    if (environment.debug_mode) {
      console.log("getPatientSubscription: " + url);
    }

    return this.http.get<PatientSubscriptionDto>(url);
  }

  updatePatientSubscription(patientId: string, centerId: string, subscriptionStatus: number): Observable<any> {

    

    const url: string = this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      `subscription-management/${patientId}`;

    const data = {
      CenterId: centerId,
      UnsubStatus: subscriptionStatus,
      UnsubBy: this.authService.currentUser.username
    };

    if (environment.debug_mode) {
      console.log("updateSubscription: " + JSON.stringify(data));
      console.log("updateSubscription url: " + url);
    }

    return this.http.put<PatientSubscriptionDto>(url, data);

  }

  IsUnsubscribeFromCommunicationMethod(unsubscribeStatus: number, communicationMethod: number): boolean {
    switch (unsubscribeStatus)
    {
        case 2: //UnsubEmail
            return communicationMethod === 1; //email
        case 3: //UnsubSms
            return communicationMethod == 2; //sms
        case 4: //UnsubAll
            return true;
        default:
            return false;
    }
  }

  downloadResponseReport(appointmentId:string):Observable<Blob> {
    
    const responseReportUrl = this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      `${appointmentId}/patient-response-report`;
    
   return this.http.get<Blob>(responseReportUrl, { responseType: "blob" as any, headers: { 'Accept': 'application/pdf' }});
  }

  updateGoogleReviewSubmitted(dto: { patientId: string; googleReviewSubmitted: boolean }): Observable<any> {
    const url = `${this.appConfig.oc_api_url}${environment.oc_api_centers_url}patient/google-review-submitted`;
    return this.http.put(url, dto);
  }


}
